export const WAR_EFFORT_MISSION_STATUS_EVENT = 'war-effort-mission-status';
export const WAR_EFFORT_ACTIVE_MISSION_EVENT = 'war-effort-active-mission';

/**
 * Push a mission-status payload to the global War Effort warning overlay.
 * Used when the world map already fetched status so warnings do not wait for a refresh.
 * @param {number|string} missionId
 * @param {object} data
 */
export function publishWarEffortMissionStatus(missionId, data) {
  if (missionId == null) {
    throw new Error('publishWarEffortMissionStatus: missionId is required');
  }
  if (!data || typeof data !== 'object') {
    throw new Error('publishWarEffortMissionStatus: data is required');
  }
  window.dispatchEvent(
    new CustomEvent(WAR_EFFORT_MISSION_STATUS_EVENT, { detail: { missionId, data } })
  );
}

/**
 * Tell the global warning overlay which mission is active so it can poll while in battle.
 * @param {number|string} missionId
 */
export function publishWarEffortActiveMission(missionId) {
  if (missionId == null) {
    throw new Error('publishWarEffortActiveMission: missionId is required');
  }
  window.dispatchEvent(
    new CustomEvent(WAR_EFFORT_ACTIVE_MISSION_EVENT, { detail: { missionId } })
  );
}
